export default __webpack_public_path__ + "static/media/resources-and-nft.c1f6dfcb.pdf";